import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function Notices() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/getDailyNotices`);
      if (response.data.success) {
        setNotices(response.data.data);
      } else {
        setError(response.data.message || 'Failed to fetch notices.');
      }
    } catch (err) {
      console.error('Error fetching notices:', err);
      setError('An error occurred while fetching notices.');
    } finally {
      setLoading(false);
    }
  };

  // Function to handle Approve/Reject
  const updateLeaveStatus = async (record, newStatus) => {
    console.log('updateLeaveStatus called with record:', record);
    const confirmMsg = `Are you sure you want to ${newStatus.toUpperCase()} this leave request?`;
    if (!window.confirm(confirmMsg)) return;
    

    try {
      // This could be a PUT or POST request; you choose what your backend expects
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/admin/updateLeaveStatus`, {
        student_id: record.student_id,
        lesson_id: record.lesson_id,
        leave_date: record.leave_date,
        newStatus: newStatus,
      });

      if (response.data.success) {
        alert(`Request ${newStatus}ed successfully!`);
        // Optionally refresh the list
        fetchNotices();
      } else {
        alert(response.data.message || 'Failed to update leave status.');
      }
    } catch (error) {
      console.error('Error updating leave status:', error);
      alert('An error occurred while updating the leave status.');
    }
  };

  if (loading) {
    return <div className="text-gray-700">Loading notices...</div>;
  }
  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <div className="w-full bg-white rounded-md shadow-lg p-6 border border-gray-200">
      <h2 className="text-2xl font-bold text-blue-700 mb-5">Leave Notices</h2>

      {notices.length === 0 ? (
        <div className="text-gray-600">No leave application notices for this period.</div>
      ) : (
        <ul className="space-y-5">
          {notices.map((notice, index) => (
            <li
              key={index}
              className="p-4 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            >
              <div className="text-lg font-semibold text-gray-800 mb-2">
                {notice.title || 'Untitled Notice'}
              </div>
              <p className="text-base text-gray-700 mb-3">
                {notice.description || 'No description provided.'}
              </p>

              {/* Buttons to Approve/Reject */}
              <div className="flex space-x-3">
                <button
                  onClick={() => updateLeaveStatus(notice, 'approved')}
                  className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                >
                  Approve
                </button>
                <button
                  onClick={() => updateLeaveStatus(notice, 'rejected')}
                  className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                >
                  Reject
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
